import { render, staticRenderFns } from "./ContributiFondoPerdutoListTable.vue?vue&type=template&id=6f7b9712&"
import script from "./ContributiFondoPerdutoListTable.vue?vue&type=script&lang=js&"
export * from "./ContributiFondoPerdutoListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports